import React from 'react';
import * as S from './HelperText.styles';

interface HelperTextProps {
  helperText: string;
  hasError?: boolean;
  hasBottomMargin?: boolean;
  hasTopMargin?: boolean;
  align?: 'left' | 'right';
}

export const HelperText: React.FC<HelperTextProps> = ({
  helperText,
  hasError,
  hasBottomMargin = true,
  hasTopMargin = true,
  align = 'left',
}) => {
  return (
    <S.Text
      $variant="4"
      $hasError={hasError}
      $hasBottomMargin={hasBottomMargin}
      $hasTopMargin={hasTopMargin}
      $align={align}
      data-testid="helper-text"
    >
      {helperText}
    </S.Text>
  );
};
